import { ActionReducer } from "@ngrx/store";
import * as fromJobActions from "../../business-objects/job/job.actions";
import { Job } from "../../business-objects/job/job.model";
import { isDefined } from "ionic-angular/util/util";

export const jobTypeReducer = (reducer): ActionReducer<any> => {
    return (state, action) => {
        state = state || {};

        if (action.type === fromJobActions.SUBMIT) {
            try {
                const user = state.user.entities[action.payload.assigneeId];

                if (isDefined(user)) {
                    action.payload = new Job({
                        ...action.payload,
                        assigneeName: user.name
                    });
                }
            } catch (e) {
                console.error("Error in jobTypeReducer", e);
            }
        }

        return reducer(state, action);
    };
};



// WEBPACK FOOTER //
// ./src/vas/store/middleware/job-type-reducer.ts